<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.editEvent.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFieldsHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row"><h3>{{ 'manageEvent.editEvent.baseInfo' | translate }}</h3></div>

    <div class="row spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('manageEvent.editEvent.eventName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.editEvent.eventNamePlaceholder' | translate"
          [(value)]="event_name"
          [invalid]="isEventNameInvalid"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="eventTypes"
          [displayKey]="'event_type_name'"
          [label]="('manageEvent.editEvent.selectEventType' | translate) + ' *'"
          [placeholder]="'manageEvent.editEvent.selectEventTypePlaceholder' | translate"
          [multiple]="false"
          [(value)]="event_type_id"
          [invalid]="isEventTypeInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="disciplineOptions"
          [displayKey]="'label'"
          [valueKey]="'value'"
          [value]="discipline"
          [label]="('manageEvent.editEvent.discipline' | translate) + (isDisciplineRequired ? ' *' : '')"
          [placeholder]="'manageEvent.editEvent.disciplinePlaceholder' | translate"
          [invalid]="isDisciplineInvalid"
          (valueChange)="discipline = $event"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-12 col-12">
        <label class="ms-2 f-14 fw-bold spacing-15">{{ 'manageEvent.editEvent.description' | translate }}</label>
        <app-markdown-editorini
          [value]="event_description"
          (valueChange)="event_description = $event"
        />
      </div>
    </div>

    <div class="row">
      <h3>{{ 'manageEvent.editEvent.dateInfo' | translate }}</h3>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-4 col-12">
        <app-input-component
          [label]="('manageEvent.editEvent.startDate' | translate) + ' *'"
          [type]="'datetime-local'"
          [placeholder]="'manageEvent.editEvent.startDatePlaceholder' | translate"
          [(value)]="start_date"
          [invalid]="isStartDateInvalid"
        />
      </div>
      <div class="col-lg-4 col-12">
        <app-input-component
          [label]="'manageEvent.editEvent.endDate' | translate"
          [type]="'datetime-local'"
          [placeholder]="'manageEvent.editEvent.endDatePlaceholder' | translate"
          [(value)]="end_date"
        />
      </div>
      <div class="col-lg-4 col-12">
        <app-input-component
          [label]="'manageEvent.editEvent.registrationDeadline' | translate"
          [type]="'datetime-local'"
          [placeholder]="'manageEvent.editEvent.registrationDeadlinePlaceholder' | translate"
          [(value)]="registration_deadline"
        />
      </div>
    </div>

    <div class="row">
      <h3>{{ 'manageEvent.editEvent.addressInfo' | translate }}</h3>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.editEvent.address' | translate"
          [placeholder]="'manageEvent.editEvent.addressPlaceholder' | translate"
          [type]="'text'"
          [(value)]="address"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.editEvent.city' | translate"
          [placeholder]="'manageEvent.editEvent.cityPlaceholder' | translate"
          [type]="'text'"
          [(value)]="city"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.editEvent.postalCode' | translate"
          [placeholder]="'manageEvent.editEvent.postalCodePlaceholder' | translate"
          [type]="'number'"
          [(value)]="postal_code"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="countries"
          [displayKey]="'name'"
          [valueKey]="'country_id'"
          [(value)]="country_id"
          [label]="'manageEvent.editEvent.country' | translate"
          [placeholder]="'manageEvent.editEvent.countryPlaceholder' | translate"
          [searchable]="true"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <h4>{{ 'manageEvent.editEvent.eventLogo' | translate }}</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="logo = $event[0]"
        />
      </div>

      <div class="col-lg-6 col-12">
        <h4>{{ 'manageEvent.editEvent.headerImage' | translate }}</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="header = $event[0]"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('common.saveChanges' | translate)"
          [disabled]="saving"
          [iconClass]="'fa fa-save'"
          (clicked)="save()"
        />
      </div>
    </div>
  </div>
</div>
